export const DEFAULT_ENTERPRISE_CONFIG = {
  enterpriseIds: {},
  experienceOverrides: {},
  name: null,
  url: null,
};

export const ENTERPRISE_CONFIG = {
  rovie: {
    enterpriseIds: {
      development: '56096b30-276c-43f8-9581-decf8802524c',
      production: 'd6c08cb0-efe7-4468-919b-bfa08ae8c802',
    },
    experienceOverrides: {},
    name: 'Rovie',
    url: 'https://www.zenbusiness.com',
  },
  squarespace: {
    enterpriseIds: {
      development: '35ec0fb4-c066-4975-80ea-4ce2a01d3b5c',
      production: 'cd6d9a80-5839-4385-9483-db3b6e793382',
    },
    experienceOverrides: {},
    name: 'Squarespace',
    url: 'https://www.squarespace.com',
  },
};

/**
 * Resolves the dashboard enterprise config for an auth-provided enterprise ID.
 *
 * @param {string} enterpriseId - ZB-generated enterprise ID from auth.
 * @returns {object|null} Matched enterprise config for a known ID, a DEFAULT_ENTERPRISE_CONFIG
 *   fallback (with id set, key=null) for unknown IDs, or null when enterpriseId is falsy.
 */
export function getEnterpriseConfig(enterpriseId) {
  if (!enterpriseId) {
    return null;
  }

  const enterpriseEntry = Object.entries(ENTERPRISE_CONFIG).find(([, enterpriseConfig]) =>
    Object.values(enterpriseConfig.enterpriseIds).includes(enterpriseId),
  );

  if (!enterpriseEntry) {
    return {
      ...DEFAULT_ENTERPRISE_CONFIG,
      id: enterpriseId,
      key: null,
    };
  }

  const [enterpriseKey, enterpriseConfig] = enterpriseEntry;

  return {
    ...enterpriseConfig,
    id: enterpriseId,
    key: enterpriseKey,
  };
}

/**
 * Normalizes a minimal enterprise object into the matching local enterprise config.
 *
 * @param {object|null|undefined} enterprise - Enterprise object, usually containing an auth-provided id.
 * @returns {object|null} Resolved enterprise config, or null.
 */
export function resolveEnterpriseConfig(enterprise) {
  if (!enterprise?.id) {
    return enterprise ?? null;
  }

  return { ...getEnterpriseConfig(enterprise.id), ...enterprise };
}
